import {all, fork} from "redux-saga/effects";


function* setTestSaga(){

}

export default function* AppSaga(){
    yield all(
        [fork(setTestSaga)]
    )
}